import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  type SuppliersOverviewQueryParams,
  type SuppliersOverviewResponse,
} from './types';
import {
  zodSuppliersOverviewQueryParamsSchema,
  zodSuppliersOverviewResponseSchema,
} from './validations';

/**
 * Fetches the paginated supplier overview list.
 *
 * All query parameter keys are camelCase and are automatically converted to
 * snake_case by the ky case-converter before the request is sent.
 *
 * @param queryParams - Optional filter and pagination parameters.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The paginated supplier overview response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-overview/operation/get_suppliers_overview_suppliers_views_overview_get
 */
export const fetchSuppliersOverview = async (
  queryParams: Partial<SuppliersOverviewQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_OVERVIEW(), {
      ...options,
      searchParams: queryParams,
      validate: {
        response: zodSuppliersOverviewResponseSchema,
        searchParams: zodSuppliersOverviewQueryParamsSchema.transform((value) =>
          withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
        ),
      },
    })
    .json<SuppliersOverviewResponse>();
